import { render, staticRenderFns } from "./QuoteRatesMarkups.vue?vue&type=template&id=59618a37"
import script from "./QuoteRatesMarkups.vue?vue&type=script&lang=js"
export * from "./QuoteRatesMarkups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59618a37')) {
      api.createRecord('59618a37', component.options)
    } else {
      api.reload('59618a37', component.options)
    }
    module.hot.accept("./QuoteRatesMarkups.vue?vue&type=template&id=59618a37", function () {
      api.rerender('59618a37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteRatesMarkups.vue"
export default component.exports